import {Box,} from "@mui/material";
import useClientQuery from "../../../global/queries/useClientQuery";
import {Navigate} from "react-router-dom";
import PageTitle from "../../../global/components/PageTitle";
import SupportAccordion from "../../../global/components/SupportAccordion";
import CompanyDataAccordion from "./Accordions/CompanyDataAccordion";
import ABKDataAccordion from "./Accordions/ABKDataAccordion";


function DashboardContent() {
    const {data: client} = useClientQuery();

    if (!client) return <Navigate  to="/login" />



    return (
        <Box sx={{maxWidth: 1000}}>
            <PageTitle title="Übersicht" />
            <ABKDataAccordion />
            <CompanyDataAccordion />
            <SupportAccordion />
        </Box>
    );
}

export default DashboardContent;
